import { useMutation } from "@apollo/client/react";
import {
  REQUEST_MAGIC_LINK,
  VERIFY_MAGIC_LINK,
  GET_OAUTH_URL,
  EXCHANGE_OAUTH_CODE,
} from "../graphql/mutations/auth";
import type { AuthPayload } from "../auth/auth-store";

// --- RequestMagicLink ---

interface RequestMagicLinkInput {
  email: string;
}

interface RequestMagicLinkResult {
  requestMagicLink: {
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
}

export function useRequestMagicLink() {
  return useMutation<RequestMagicLinkResult, { input: RequestMagicLinkInput }>(
    REQUEST_MAGIC_LINK,
  );
}

// --- VerifyMagicLink ---

interface VerifyMagicLinkInput {
  token: string;
}

interface VerifyMagicLinkResult {
  verifyMagicLink: AuthPayload;
}

export function useVerifyMagicLink() {
  return useMutation<VerifyMagicLinkResult, { input: VerifyMagicLinkInput }>(
    VERIFY_MAGIC_LINK,
  );
}

// --- GetOauthUrl ---

interface GetOauthUrlInput {
  provider: string; // GITHUB | GOOGLE (backend enum, uppercase)
}

interface GetOauthUrlResult {
  getOauthUrl: {
    authorizationUrl: string;
    state: string;
  };
}

export function useGetOauthUrl() {
  return useMutation<GetOauthUrlResult, { input: GetOauthUrlInput }>(
    GET_OAUTH_URL,
  );
}

// --- ExchangeOauthCode ---

interface ExchangeOauthCodeInput {
  code: string;
  state: string;
  provider: string; // GITHUB | GOOGLE (backend enum, uppercase)
}

interface ExchangeOauthCodeResult {
  exchangeOauthCode: AuthPayload;
}

export function useExchangeOauthCode() {
  return useMutation<
    ExchangeOauthCodeResult,
    { input: ExchangeOauthCodeInput }
  >(EXCHANGE_OAUTH_CODE);
}
